import {AxiosError} from 'axios';
import {APIServiceImpl, ServiceResponse} from '../api';
import {DownloadInviteParams, DownloadInviteResponse} from './download-invite-params';
import {DownloadInviteService} from './download-invite.service';

export class DownloadInviteServiceImpl extends APIServiceImpl implements DownloadInviteService {
  static readonly SEND_DOWNLOAD_INVITE = '/download-invite';

  async sendDownloadInvite(params: DownloadInviteParams): Promise<ServiceResponse<DownloadInviteResponse>> {
    try {
      const response = await this.post(DownloadInviteServiceImpl.SEND_DOWNLOAD_INVITE, params);
      return new ServiceResponse<DownloadInviteResponse>(response.data as DownloadInviteResponse);
    } catch (e: unknown) {
      const error = this.parseErrorResponse(e as AxiosError);
      return new ServiceResponse<DownloadInviteResponse>(undefined, error);
    }
  }

  private parseErrorResponse(error: AxiosError): string {
    if (error.response != null) {
      const status = error.response.status;
      const data = error.response.data as Record<string, unknown> | undefined;

      if (status === 400) {
        return (data?.message as string) ?? (data?.error as string) ?? 'Invalid phone number. Please check your input and try again.';
      }
      if (status === 429) {
        return (data?.message as string) ?? 'Too many requests. Please wait a moment and try again.';
      }
      if (status === 500) {
        return 'Server error. Please try again later.';
      }
      return (data?.message as string) ?? (data?.error as string) ?? `Request failed with status ${status}`;
    }
    return error.message ?? 'Network error. Please check your connection and try again.';
  }
}
